import React from 'react';
import Templates from './subcomponents/Templates';

const ScriptManagement = () => (
    <Templates />
);

export default ScriptManagement;
